"use strict";
/**
 * localStorage 操作
 *
 * ### Example
 * ```
 * LS.set('name', 'coder');
 * LS.get('name');
 * LS.remove('name');
 * ```
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LS = void 0;
var ls = window.localStorage;
exports.LS = {
    set: function (key, value) {
        if (ls) {
            try {
                ls.setItem(key, value);
                return true;
            }
            catch (e) {
                e.code === 22 && ls.clear();
            }
        }
        return false;
    },
    get: function (key) {
        return ls ? ls.getItem(key) : void 0;
    },
    remove: function (key) {
        ls && ls.removeItem(key);
    }
};
